const OAUTH = {
  token: {
    post: "/oauth/token/"
  },
  revoke_token: {
    post: "/oauth/revoke_token/"
  }
};
const USERS$1 = {
  post: "/3/users/",
  me: {
    get: "/3/users/me/",
    patch: "/3/users/me/",
    delete: "/3/users/me/",
    pictures: {
      post: "/3/users/me/pictures/"
    },
    moneyboxes: {
      get: "/3/moneyboxes/"
    },
    company: {
      get: "/v4/users/me/company/",
      post: "/v4/users/me/company/",
      patch: "/v4/users/me/company/"
    },
    legalOwner: {
      get: "/v4/users/me/legal/",
      post: "/v4/users/me/legal/",
      patch: "/v4/users/me/legal/"
    }
  },
  details: {
    get: (id) => `/3/users/${id}/`
  }
};
const PASSWORD = {
  post: "/3/manage-password/"
};
const CERTIFY_PHONE = {
  get: "/3/certify-phone/",
  post: "/3/certify-phone/"
};
const MANGOPAY$1 = {
  iban: {
    get: "/3/mangopay/iban/",
    post: "/3/mangopay/iban/"
  },
  uboDeclaration: {
    get: "/3/mangopay/ubo-declaration/",
    patch: "/3/mangopay/ubo-declaration/",
    users: {
      get: (idUbo) => `/3/mangopay/ubo-declaration/${idUbo}/ubo/`,
      post: (idUbo) => `/3/mangopay/ubo-declaration/${idUbo}/ubo/`,
      patch: (idUbo, idMangopayUser) => `/3/mangopay/ubo-declaration/${idUbo}/ubo/${idMangopayUser}/`
    }
  },
  payin: {
    get: "/3/mangopay/payin/"
  },
  payout: {
    get: "/3/mangopay/payout/"
  }
};
const INSURANCE = {
  get: "/3/insurance/",
  condition: {
    get: (idUser) => `/3/insurance/condition/${idUser}/`,
    patch: (idUser) => `/3/insurance/condition/${idUser}/`,
    post: (idUser) => `/3/insurance/condition/${idUser}/`
  },
  productCondition: {
    get: (idProduct) => `/3/insurance/condition/product/${idProduct}/`,
    patch: (idProduct) => `/3/insurance/condition/product/${idProduct}/`,
    post: (idProduct) => `/3/insurance/condition/product/${idProduct}/`
  },
  similar: {
    get: (slug) => `/3/insurance/similar/${slug}/`
  },
  details: {
    get: (slug) => `/3/insurance/${slug}/`
  },
  rentalCover: {
    get: "/v4/rental-cover/conditions/"
  }
};
const WISHLIST = {
  get: "/3/wishlists/",
  post: "/3/wishlists/",
  details: {
    get: (slug) => `/3/wishlist/${slug}/`,
    delete: (slug) => `/3/wishlist/${slug}/`,
    patch: (slug) => `/3/wishlist/${slug}/`,
    product: {
      post: (slug) => `/3/wishlist/${slug}/product/`,
      delete: (slug) => `/3/wishlist/${slug}/product/`
    }
  }
};
const CHATS = {
  get: "/3/chats/",
  details: {
    get: (idChat) => `/3/chats/${idChat}/`,
    messages: {
      post: (idChat) => `/3/chats/${idChat}/messages/`,
      patch: (idMessage) => `/3/chats/messages/${idMessage}/`
    }
  }
};
const FAQ = {
  get: "/3/faq/",
  topic: {
    get: (topic) => `/3/faq/user/${topic}/`
  }
};
const REFERENTIAL = {
  get: "/3/referential/",
  stats: {
    get: "/v4/reviews/stats/"
  }
};
const LOG_AS = {
  post: "/v4/users/auth/log-as/"
};
const BRANDS = {
  get: "/v4/brands/",
  models: {
    get: "/v4/brands-models/"
  }
};
const MANUFACTURERS = {
  get: "/v4/manufacturers/",
  models: {
    get: "/v4/manufacturers-models/"
  }
};
const SEARCH = {
  get: "/3/search_locations/",
  info: {
    get: "/3/info_location/"
  },
  products: {
    get: "/3/products/"
  }
};
const BOOKINGS_GUEST = {
  get: "/v4/bookings-guest/",
  post: "/v4/bookings/",
  options: {
    get: "/v4/bookings-guest/options/"
  },
  details: {
    get: (id) => `/v4/bookings-guest/${id}/`,
    patch: (id) => `/v4/bookings-guest/${id}/`,
    prices: {
      get: (id) => `/3/my-requests/${id}/prices/`,
      patch: (id) => `/3/my-requests/${id}/prices/`
    },
    snooze: {
      patch: (id) => `/v4/bookings-guest/${id}/snooze/`
    },
    cancel: {
      patch: (id) => `/v4/bookings-guest/${id}/cancel/`
    },
    validate: {
      patch: (id) => `/v4/bookings-guest/${id}/validate/`
    },
    extensions: {
      post: (id) => `/v4/bookings-guest/${id}/extensions/`,
      validate: {
        patch: (id) => `/v4/bookings-guest/${id}/extensions/validate/`
      },
      confirm: {
        get: (id) => `/v4/bookings-guest/${id}/extensions/confirm/`
      },
      cancel: {
        patch: (id) => `/v4/bookings-guest/${id}/extensions/cancel/`
      },
      details: {
        delete: (id, idExtension) => `/v4/bookings-guest/${id}/extensions/${idExtension}/`
      }
    },
    upgrades: {
      get: (id) => `/v4/bookings-guest/${id}/upgrades/`,
      post: (id) => `/v4/bookings-guest/${id}/upgrades/`,
      validate: {
        patch: (id) => `/v4/bookings-guest/${id}/upgrades/validate/`
      },
      cancel: {
        patch: (id) => `/v4/bookings-guest/${id}/upgrades/cancel/`
      },
      details: {
        delete: (id, idUpgrade) => `/v4/bookings-guest/${id}/upgrades/${idUpgrade}/`
      }
    },
    insurance: {
      post: (id) => `/3/my-requests/${id}/options/`
    },
    payment: {
      get: (id) => `/3/my-requests/${id}/payment/`
    },
    payments: {
      get: (id) => `/3/my-requests/${id}/payments/`,
      summary: {
        get: (id) => `/3/my-requests/${id}/payment/summary/`,
        post: (id) => `/3/my-requests/${id}/payment/summary/`
      },
      confirm: {
        post: (id) => `/3/my-requests/${id}/payment/confirm/`
      },
      webRedirect: {
        get: (id) => `/3/my-requests/${id}/payment/web-redirect/`
      },
      final: {
        get: (id) => `/3/my-requests/${id}/payment/final/`
      },
      async: {
        get: (id, payinId) => `/3/my-requests/${id}/payment/async/${payinId}/`,
        post: (id) => `/3/my-requests/${id}/payment/async/`
      }
    },
    refund: {
      get: (id) => `/3/my-requests/${id}/refund/`
    }
  }
};
const BOOKINGS_OWNER = {
  get: "/v4/bookings-owner/",
  options: {
    get: "/v4/bookings-owner/options/"
  },
  details: {
    get: (id) => `/v4/bookings-owner/${id}/`,
    accept: {
      patch: (id) => `/v4/bookings-owner/${id}/accept/`
    },
    cancel: {
      patch: (id) => `/v4/bookings-owner/${id}/cancel/`
    },
    refuse: {
      patch: (id) => `/v4/bookings-owner/${id}/refuse/`
    },
    extensions: {
      accept: {
        patch: (id) => `/v4/bookings-owner/${id}/extensions/accept/`
      },
      refuse: {
        patch: (id) => `/v4/bookings-owner/${id}/extensions/refuse/`
      }
    },
    prices: {
      get: (id) => `/3/my-bookings/${id}/prices/`
    }
  }
};
const REVIEWS = {
  get: "/v4/reviews/",
  details: {
    post: (idBooking) => `/3/review/create/${idBooking}/`,
    get: (idReview) => `/3/review/${idReview}/`,
    patch: (idReview) => `/3/review/${idReview}/`,
    photo: {
      patch: (idReview) => `/3/review/${idReview}/photo/`
    },
    report: {
      patch: (idReview) => `/3/review/${idReview}/report/`
    }
  },
  needed: {
    get: "/3/reviews-needed/"
  }
};
const VEHICLES$1 = {
  details: {
    post: "/v4/vehicles/",
    get: (idVehicle) => `/v4/vehicles/${idVehicle}/`,
    patch: (idVehicle) => `/v4/vehicles/${idVehicle}/`,
    equipments: {
      get: (idVehicle) => `/v4/vehicles/${idVehicle}/equipments/`,
      patch: (idVehicle) => `/v4/vehicles/${idVehicle}/equipments/`
    },
    photos: {
      get: (idVehicle) => `/v4/vehicles/${idVehicle}/photos/`,
      post: (idVehicle) => `/v4/vehicles/${idVehicle}/photos/`,
      details: {
        patch: (idVehicle, idPhoto) => `/v4/vehicles/${idVehicle}/photos/${idPhoto}/`,
        delete: (idVehicle, idPhoto) => `/v4/vehicles/${idVehicle}/photos/${idPhoto}/`,
        rotate: {
          patch: (idVehicle, idPhoto) => `/v4/vehicles/${idVehicle}/photos/${idPhoto}/rotate`
        }
      }
    },
    sleepings: {
      get: (idVehicle) => `/v4/vehicles/${idVehicle}/sleepings/`,
      post: (idVehicle) => `/v4/vehicles/${idVehicle}/sleepings/`,
      delete: (idVehicle, idSleeping) => `/v4/vehicles/${idVehicle}/sleepings/${idSleeping}/`
    }
  }
};
const PRODUCTS$1 = {
  me: {
    get: "/3/products/me/paginated/",
    filters: {
      get: "/3/products/me/filters/"
    }
  },
  details: {
    post: (idProduct) => `/3/products/${idProduct}/update/`,
    get: (idProduct) => `/3/products/${idProduct}/`,
    delete: (idProduct) => `/3/products/${idProduct}/update/`,
    preferences: {
      patch: (idProduct) => `/3/products/${idProduct}/update/preferences/`
    },
    photo: {
      put: (idProduct, idPicture) => `/3/products/${idProduct}/photos/${idPicture}/`,
      delete: (idProduct, idPicture) => `/3/products/${idProduct}/photos/${idPicture}/`
    },
    stats: {
      get: (idProduct) => `/3/products/${idProduct}/stats/`
    },
    progress: {
      get: (idProduct) => `v4/products/${idProduct}/progress/`
    },
    calendar: {
      periods: {
        get: (idProduct) => `/3/products/${idProduct}/calendar/periods/`,
        post: (idProduct) => `/3/products/${idProduct}/calendar/periods/`,
        details: {
          patch: (idProduct, idPeriod) => `/3/products/${idProduct}/calendar/periods/${idPeriod}/`,
          delete: (idProduct, idPeriod) => `/3/products/${idProduct}/calendar/periods/${idPeriod}/`
        }
      },
      prices: {
        get: (idProduct) => `/3/products/${idProduct}/calendar/prices/`,
        post: (idProduct) => `/3/products/${idProduct}/calendar/prices/`,
        details: {
          patch: (idProduct, idPrice) => `/3/products/${idProduct}/calendar/prices/${idPrice}/`,
          delete: (idProduct, idPrice) => `/3/products/${idProduct}/calendar/prices/${idPrice}/`
        }
      },
      feed: {
        get: (idProduct) => `/3/products/${idProduct}/calendar-feed/`,
        post: (idProduct) => `/3/products/${idProduct}/ical-feed/`,
        delete: (idProduct) => `/3/products/${idProduct}/ical-feed/`
      }
    },
    prices: {
      request: {
        get: (idProduct) => `/3/products/${idProduct}/price/`
      },
      get: (idProduct) => `/3/products/${idProduct}/prices-details/`,
      patch: (idProduct) => `/3/products/${idProduct}/prices-details/`
    },
    options: {
      post: (idProduct) => `/3/products/${idProduct}/options/`,
      patch: (idProduct) => `/3/products/${idProduct}/options/`,
      delete: (idProduct) => `/3/products/${idProduct}/options/`
    },
    availabilities: {
      get: (idProduct) => `/3/products/${idProduct}/availabilities/`
    },
    goboony: {
      duplicateRedirectUrl: (id) => `/v4/goboony/listing/${id}/redirect-url/`
    }
  }
};
const DOCUMENTS$1 = {
  details: {
    get: (idDocument) => `/3/docs/${idDocument}/`,
    patch: (idDocument) => `/3/docs/${idDocument}/`,
    vehicle: {
      get: (idVehicle) => `/3/docs/vehicle/${idVehicle}/`
    },
    booking: {
      get: (idBooking) => `/3/docs/booking/${idBooking}/`
    },
    guest: {
      get: (idUser) => `/3/docs/guest/${idUser}/`
    },
    owner: {
      get: (idUser) => `/3/docs/owner/${idUser}/`
    },
    page: {
      post: (idDocument) => `/3/docs/${idDocument}/pages/`,
      delete: (idDocument, idPage) => `/3/docs/${idDocument}/pages/${idPage}/`
    },
    doctective: {
      check: "/v4/doctective/check/"
    }
  }
};
const GEOLOCATION = {
  places: {
    get: "/v4/geolocation/places/"
  }
};
const LEAD_SOURCE = {
  get: (id) => `/v4/leads/lead-sources/${id}/`
};
const NEWSLETTER = {
  register: {
    post: (url) => `${url}/contacts/`
  }
};
const EARNINGS = {
  simulate: {
    post: "/v4/campers/earnings-simulation/"
  }
};
const EVENTS = {
  post: "/v4/events/send/"
};
const useIsObject = (x) => typeof x === "object" && !Array.isArray(x) && x !== null;
const useObjectToURLSearchParams = (o) => useIsObject(o) ? new URLSearchParams(Object.entries(o)) : new URLSearchParams();
const Auth = ({ $request }) => ({
  async login(payload) {
    const payloadEncoded = useObjectToURLSearchParams(payload);
    payloadEncoded.set("grant_type", "password");
    return await $request({
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      url: OAUTH.token.post,
      method: "post",
      data: payloadEncoded.toString()
    });
  },
  async refresh(payload) {
    const payloadEncoded = useObjectToURLSearchParams(payload);
    payloadEncoded.set("grant_type", "refresh_token");
    return await $request({
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      url: OAUTH.token.post,
      method: "post",
      data: payloadEncoded.toString()
    });
  },
  async logout(payload) {
    const payloadEncoded = useObjectToURLSearchParams(payload);
    await $request({
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      url: OAUTH.revoke_token.post,
      method: "post",
      data: payloadEncoded.toString()
    });
  }
});
const LogAs = ({ $request }) => ({
  async byUserId(payload) {
    return await $request({
      url: LOG_AS.post,
      method: "post",
      data: payload
    });
  }
});
const useIsString = (x) => Object.prototype.toString.call(x) === "[object String]";
const useToDateISOStringWithoutTimezone = ({ dateString, hours = 0 }) => {
  if (dateString === void 0) {
    return void 0;
  }
  if (!useIsString(dateString)) {
    return null;
  }
  if (dateString.endsWith("Z")) {
    return dateString.slice(0, -1);
  }
  const dateTimeSeparatorChar = dateString.charAt(10);
  if (dateTimeSeparatorChar === "T") {
    return dateString;
  }
  if (dateTimeSeparatorChar === " ") {
    return `${dateString.substring(0, 10)}T${dateString.substring(10 + 1)}`;
  }
  return `${dateString}T${String(hours).padStart(2, "0")}:00:00`;
};
const parseUserForApp = (user) => {
  if ("borned_on" in user) {
    user.borned_on = useToDateISOStringWithoutTimezone({ dateString: user.borned_on });
  }
  user.joined_at = useToDateISOStringWithoutTimezone({ dateString: user.joined_at });
  return user;
};
const parseMoneyboxListForApp = (moneyboxes) => {
  moneyboxes.forEach((m) => {
    m.expire_at = useToDateISOStringWithoutTimezone({ dateString: m.expire_at });
  });
  return moneyboxes;
};
const useIsDate = (date) => Boolean(date) && !isNaN(date) && typeof date.getMonth === "function";
const useToDateISOStringWithoutTime = ({ date }) => {
  if (date === void 0) {
    return void 0;
  }
  if (!date || !useIsDate(new Date(date))) {
    return null;
  }
  if (useIsString(date)) {
    date = new Date(date);
  }
  const tz = date.getTimezoneOffset() * 6e4;
  return new Date(date.getTime() - tz).toISOString().substring(0, 10);
};
const formatUserforAPI = (form) => {
  const payload = Object.assign({}, form);
  if ("borned_on" in payload) {
    payload.borned_on = useToDateISOStringWithoutTime({ date: payload.borned_on });
  }
  return payload;
};
const Users = ({ $request }) => ({
  async create(payload) {
    const data = await $request({
      url: USERS$1.post,
      method: "post",
      data: formatUserforAPI(payload)
    });
    return parseUserForApp(data);
  },
  async getMe() {
    const data = await $request({
      url: USERS$1.me.get,
      method: "get"
    });
    return parseUserForApp(data);
  },
  async updateMe(payload) {
    const data = await $request({
      url: USERS$1.me.patch,
      method: "patch",
      data: formatUserforAPI(payload)
    });
    return parseUserForApp(data);
  },
  async deleteMe() {
    return await $request({
      url: USERS$1.me.delete,
      method: "delete"
    });
  },
  async getById(id) {
    const data = await $request({
      url: USERS$1.details.get(id),
      method: "get"
    });
    return parseUserForApp(data);
  },
  async postProfilePictures(payload) {
    return await $request({
      url: USERS$1.me.pictures.post,
      method: "post",
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  async getMoneyboxes() {
    const data = await $request({
      url: USERS$1.me.moneyboxes.get,
      method: "get"
    });
    return parseMoneyboxListForApp(data);
  },
  async getCompany() {
    return await $request({
      url: USERS$1.me.company.get,
      method: "get"
    });
  },
  async createCompany(payload) {
    return await $request({
      url: USERS$1.me.company.post,
      method: "post",
      data: payload
    });
  },
  async updateCompany(payload) {
    return await $request({
      url: USERS$1.me.company.patch,
      method: "patch",
      data: payload
    });
  },
  async getLegalOwner() {
    return await $request({
      url: USERS$1.me.legalOwner.get,
      method: "get"
    });
  },
  async createLegalOwner(payload) {
    return await $request({
      url: USERS$1.me.legalOwner.post,
      method: "post",
      data: formatUserforAPI(payload)
    });
  },
  async updateLegalOwner(payload) {
    return await $request({
      url: USERS$1.me.legalOwner.patch,
      method: "patch",
      data: formatUserforAPI(payload)
    });
  }
});
const Password = ({ $request }) => ({
  async post(payload) {
    await $request({
      url: PASSWORD.post,
      method: "post",
      data: payload
    });
  }
});
const parsePaymentHistoryListForApp = (paymentHistory) => {
  paymentHistory.list.forEach((p) => {
    p.execution_date = useToDateISOStringWithoutTimezone({ dateString: p.execution_date });
  });
  return paymentHistory;
};
const formatUserUBOForAPI = (form) => {
  return {
    ...form,
    birthday: useToDateISOStringWithoutTime({ date: form.birthday })
  };
};
const DOCUMENTS = {
  TYPE: {
    ADDRESS_PROOF: "addr_proof",
    COVID_PROOF: "covid_proof",
    REGISTRATION_PROOF: "reg_proof",
    REGISTRATION_ASSOCIATION: "reg_association",
    SHAREHOLDER_DECLARATION: "shareholder_decl",
    ID_PROOF: "id_proof",
    UBO_DECLARATION: "ubo_declaration",
    CAR_REGISTRATION: "car_registr",
    CAR_PROOF_INSURANCE: "car_proof_insu",
    DRIVING_LICENCE: "driving_licen",
    MOT: "MOT",
    IBAN: "iban",
    DVLA: "dvla",
    TAX_IDENTIFICATION_NUMBER: "tax_identification_number",
    RENTING_CONTRACT: "rent_cont",
    // in sinister cases
    DETAIL_DECLARATION: "detail_decl"
    // in sinister cases
  },
  STATUS: {
    CREATED: "created",
    ADDED: "added",
    VALIDATION_ASKED: "valid_ask",
    VALIDATED: "validated",
    EXTERNAL_TRANSMISSION: "external_transmission",
    // When a document isn't handled by API. Ex: DVLA for UK bookings, only frontend
    NEEDDOC: "needdoc",
    // When a document doesn't need an uploaded file first, but it does after expiration. Ex: MOT for brand new vehicules
    REFUSED: "refused",
    REFUSED_MANGOPAY: "refuse_mgp",
    EXPIRED_SOON: "exp_soon",
    EXPIRED: "expired"
  }
};
const BOOKING_UPGRADES = {
  STATE: {
    CREATED: "CREATED",
    ACCEPTED: "ACCEPTED",
    CONFIRMED: "CONFIRMED",
    CANCEL_GUEST: "CANCEL_GUEST"
  },
  REASON: {
    BUYBACK: "buyback",
    RENTAL_COVER: "rental_cover",
    SECOND_DRIVER: "second_driver"
  }
};
const BOOKING_EXTENSIONS = {
  STATE: {
    CREATED: "CREATED",
    GUEST_ASKED: "GUEST_ASK",
    ACCEPTED: "ACCEPTED",
    CANCELLED_OWNER: "CANCEL_OWNER",
    CONFIRMED: "CONFIRMED",
    CANCELLED_GUEST: "CANCEL_GUEST"
  },
  REASON: {
    DAY_BEFORE: "day_before",
    DAY_AFTER: "day_after",
    KM_100: "km_100",
    KM_200: "km_200",
    KM_UNLIMITED: "km_unlimited",
    DAY_SLIDE: "day_slide"
  }
};
const MANGOPAY = {
  UBO_DECLARATION_STATUS: {
    C: DOCUMENTS.STATUS.CREATED,
    A: DOCUMENTS.STATUS.VALIDATION_ASKED,
    V: DOCUMENTS.STATUS.VALIDATED,
    I: DOCUMENTS.STATUS.REFUSED,
    R: DOCUMENTS.STATUS.REFUSED
  }
};
const BOOKINGS = {
  LISTING_STATE: {
    TO_DO: "todo",
    CONFIRMED: "confirmed",
    WAITING: "waiting",
    ARCHIVED: "archived"
  },
  STATUS: {
    CREATED: "CREATED",
    /** @deprecated since 2016 */
    CREATED_PRO: "CREATED_PRO",
    ABANDONED: "ABANDONED",
    VALIDATED: "VALIDATED",
    ACCEPTED: "ACCEPTED",
    ACCEPTED_EXPIRED: "ACCEPTED_EXP",
    ONGOING: "ONGOING",
    TO_COME_NOT_PAID: "TO_COME_NOT_PAID",
    TO_COME: "TO_COME",
    DONE: "DONE",
    CANCELLED_STAFF: "CANCELLED_STAFF",
    CANCELLED_GUEST: "CANCELLED_GUEST",
    CANCELLED_OWNER: "CANCELLED_OWNER",
    CANCELLED_BOTH: "CANCELLED_BOTH"
  },
  PLAN_REFUND: {
    ON_TIME: "ON_TIME",
    TOO_LATE: "TOO_LATE"
  },
  CANCEL_REASON: {
    GUEST: {
      REASON_OWNER: "REASON_OWNER",
      REASON_CORONA: "REASON_CORONA",
      REASON_OTHER: "REASON_OTHER",
      REASON_DUPLICATE_BOOKING: "DUPLICATE",
      REASON_COMPETITORS: "COMPETITORS",
      REASON_CAMPER_COMPETITORS: "OTHER_COMPETITORS",
      REASON_CANCEL_HOLIDAYS: "CANCEL_HOLIDAYS",
      REASON_CASUALTY: "REASON_CASUALTY"
    },
    OWNER: {
      REASON_KM: "REASON_KM",
      REASON_DATE: "REASON_DATE",
      REASON_UNAVAILABLE_CALENDAR: "REASON_UNAVAILABLE",
      /** @deprecated */
      REASON_UNAVAILABLE_BOOKING: "REASON_UNAVA_ASKED",
      /** @deprecated */
      REASON_DOWN: "REASON_DOWN",
      REASON_SNOW: "REASON_SNOW",
      REASON_BABY: "REASON_BABY",
      REASON_ANIMAL: "REASON_ANIMAL",
      REASON_SMOKING: "REASON_SMOKING",
      REASON_TRIP: "REASON_TRIP",
      REASON_SEAT: "REASON_SEAT",
      REASON_PURPOSE: "RESON_PURPOSE",
      /** @deprecated */
      REASON_GUEST: "REASON_GUEST",
      REASON_OTHER: "REASON_OTHER",
      /** @deprecated */
      REASON_DOUBT_COVID: "REASON_DOUBT_COVID",
      REASON_OLD_PRICE: "REASON_OLD_PRICE",
      REASON_UNAVAILABLE_FOR_INVENTORY: "REASON_UNAVAILABLE_FOR_INVENTORY"
    }
  },
  REFUND_REASON: {
    REASON_EMERGENCY: "REASON_CORONA",
    REASON_OTHER: "REASON_OTHER",
    REASON_OWNER: "REASON_OWNER"
  },
  PAYMENT_TYPE: {
    UNKNOWN: "unknow",
    CARD: "card",
    CARD_2X: "card_2",
    CREDIT_4X: "cred_4",
    HOLIDAY_VOUCHERS: "ho_vou",
    TRANSFER: "transf",
    SOFORT: "sofort",
    MONEYBOX: "moneyb",
    PAYPAL: "paypal",
    KLARNA: "klarna",
    IDEAL: "ideal",
    MBWAY: "mbway"
  },
  PAYMENT_STATE: {
    UNKNOWN: "unknow",
    SUGGESTED: "suggest",
    SELECTED: "select",
    TO_COME: "to_come",
    IN_PROGRESS: "in_prog",
    DONE: "done",
    FAILED: "failed",
    CANCELLED: "cancel"
  },
  PAYMENT_REASON: {
    UNKNOWN: "unknow",
    REASON_BOOKING: "book",
    REASON_EXTENTION: "exten",
    REASON_EXTENTION_GROUP: "exteng",
    REASON_SINISTER: "sinist",
    REASON_GIFT_CARD: "gftcrd",
    REASON_DEPOSIT: "depos",
    REASON_GOODWILL: "gest",
    REASON_REFUND: "refund",
    REASON_MONEYBOX: "moneyb",
    REASON_TOLLS_AND_FINES: "tolls"
  },
  PAYMENT_MBWAY_STATUS: {
    CREATED: "CREATED",
    SUCCEEDED: "SUCCEEDED",
    FAILED: "FAILED"
  },
  HOURS: {
    DEPARTURE_MORNING: 9,
    ARRIVAL_MORNING: 12,
    DEPARTURE_AFTERNOON: 14,
    ARRIVAL_AFTERNOON: 20
  },
  SECOND_DRIVER: {
    SELECTED: "selected",
    NOT_SELECTED: "not_selected",
    INCLUDED: "included",
    NOT_AVAILABLE: "not_available"
  }
};
const BOOKING_KM_OPTION = {
  UNLIMITED: 0,
  KM_100: 100,
  KM_200: 200
};
const EXTENSIONS = {
  STATUS: {
    CREATED: "CREATED",
    GUEST_ASKED: "GUEST_ASK",
    ACCEPTED: "ACCEPTED",
    CONFIRMED: "CONFIRMED",
    CANCELLED_OWNER: "CANCEL_OWNER",
    CANCELLED_GUEST: "CANCEL_GUEST"
  },
  REASONS: {
    DAY_BEFORE: "day_before",
    DAY_AFTER: "day_after",
    KM_100: "km_100",
    KM_200: "km_200",
    KM_UNLIMITED: "km_unlimited",
    INSURANCE_DAY_BEFORE: "ins_day_before",
    INSURANCE_DAY_AFTER: "ins_day_after",
    BUYBACK: "buyback"
  }
};
const PRICES = {
  COLORS: [
    { value: 0, name: "DEFAULT", hex: "#e4e4e7" },
    { value: 1, name: "blue", hex: "#BFDBFE" },
    { value: 2, name: "orange", hex: "#FDBA74" },
    { value: 3, name: "yellow", hex: "#FDE68A" },
    { value: 4, name: "pink", hex: "#FBCFE8" },
    { value: 5, name: "purple", hex: "#DDD6FE" },
    { value: 6, name: "green", hex: "#A1FDBE" }
  ],
  COLOR_DEFAULT: { value: 0, name: "DEFAULT", hex: "#e4e4e7" },
  DEPOSIT_MEAN: ["card", "check", "cash", "transfer", "others"]
};
const USERS = {
  TYPES: {
    GUEST: "guest",
    OWNER: "owner"
  },
  PROFESIONAL_TYPES: {
    SOLE_TRADER: "SOLETRADER",
    BUSINESS: "BUSINESS",
    PARTNERSHIP_DE: "PARTNERSHIP_DE",
    PARTNERSHIP_NL: "PARTNERSHIP_NL"
  }
};
const PRODUCTS = {
  STATUS: {
    CREATED: "created",
    TO_MODERATE: "to_moderate",
    PUBLISHED: "published",
    BOOKABLE: "bookable",
    UNPUBLISHED: "unpublished",
    UNPUBLISHED_OWNER: "unpublished_owner",
    DELETED: "deleted",
    DELETED_OWNER: "deleted_owner"
  },
  REASON_SUSPEND_DELETE: {
    DOUBLE_PRODUCT: "DELETE_DOUBLE",
    VEHICLE_SOLD: "DELETE_SOLD",
    WANT_TO_SOLD_VEHICLE: "DELETE_W_SOLD",
    VEHICLE_KO: "DELETE_HS",
    NOT_ENOUGH_BOOKINGS: "DELETE_NO_BK",
    DISAGREE_YESCAPA: "DELETE_SITE",
    BAD_EXPERIENCE_YESCAPA: "DELETE_BAD_EXP",
    PERSONNAL_USE: "DELETE_PERSO",
    OTHER: "REASON_NONE"
  },
  TYPES: {
    LOWPROFILE: 1,
    COACHBUILT: 2,
    ACLASS: 3,
    CAMPERVAN: 4,
    VAN: 5,
    CARAVAN: 6,
    OTHER: 7
  },
  OWNER_ACCEPTANCE_STATUS: {
    ON_DEMAND: "ON_DEMAND",
    ALLOWED: "ALLOWED",
    NOT_ALLOWED: "NOT_ALLOWED"
  },
  NON_AVAILABLE_REASON: {
    PERSONAL_USE: "PERSONAL_USE",
    OTHER_WEBSITE: "OTHER_WEBSITE",
    BREAKDOWN: "BREAKDOWN",
    WINTERING: "WINTERING",
    OTHER: "OTHER",
    GOBOONY_BOOKING: "GOBOONY_BOOKING",
    GOBOONY_OWNER: "GOBOONY_OWNER"
  },
  OPTION_RECURRENCE: {
    DAY: "day",
    BOOKING: "booking"
  }
};
const INSURANCES = {
  OWNER_MANAGED_INSURANCE_SLUG: "none"
};
const VEHICLES = {
  PICTURES: {
    MIN_WIDTH: 638,
    // from django apps/vehicles/constants/__init__.py L227, L228
    MIN_HEIGHT: 426,
    // from django apps/vehicles/constants/__init__.py L227, L228
    MAX_SIZE: 10
    // Arbitrary value
  },
  AVAILABILITY: {
    AVAILABLE: "Available",
    NOT_AVAILABLE: "NotAvailable"
  },
  DRIVING_LICENCE: {
    B: "B",
    C: "C"
  }
};
const BOOKING_REQUEST = {
  PURPOSES: {
    HOLIDAYS_FAMILY: "HOLIDAYS_FAMILY",
    HOLIDAYS_COUPLE: "HOLIDAYS_COUPLE",
    HOLIDAYS_FRIENDS: "HOLIDAYS_FRIENDS",
    RENT_BEFORE_BUY: "RENT_BEFORE_BUY",
    FAMILY_EVENT: "FAMILY_EVENT",
    SPORT_EVENT: "SPORT_EVENT",
    MUSICAL_EVENT: "MUSICAL_EVENT",
    OTHER: "OTHER"
  }
};
const ERROR_PRICE_BOOKING_CODE = {
  INVERTED_DATES: "103",
  // date_to > date_from
  INVALID_DOCUMENTS: "104",
  // guest with invalid document and date_from < 72h
  KM_UNLIMITED_NOT_ALLOWED: "106",
  // with unavailable unlimited km option
  NOT_AVAILABLE: "107",
  // with unavailable date
  MIN_DAYS_REQUIRED: "108",
  // with not enough days
  CLOSED_DAYS: "109"
  // dat_from or date_two is a closed day (pro owner only)
};
const BOOKING_PAYMENT_METHODS = {
  CREDIT_CARD: "card",
  CREDIT_CARD_2x: "card_2",
  CREDIT_CARD_4x: "cred_4",
  KLARNA: "sofort",
  PAYPAL: "paypal",
  IDEAL: "ideal",
  MBWAY: "mbway"
};
const CAMPER_SEASON_TYPE = {
  LOW_SEASON: 1,
  HIGH_SEASON: 3
};
const Constants = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BOOKINGS,
  BOOKING_EXTENSIONS,
  BOOKING_KM_OPTION,
  BOOKING_PAYMENT_METHODS,
  BOOKING_REQUEST,
  BOOKING_UPGRADES,
  CAMPER_SEASON_TYPE,
  DOCUMENTS,
  ERROR_PRICE_BOOKING_CODE,
  EXTENSIONS,
  INSURANCES,
  MANGOPAY,
  PRICES,
  PRODUCTS,
  USERS,
  VEHICLES
}, Symbol.toStringTag, { value: "Module" }));
const parseMangopayIbanForApp = (iban) => {
  const documentBase = {
    id: DOCUMENTS.TYPE.IBAN,
    document_type: DOCUMENTS.TYPE.IBAN,
    status: iban ? DOCUMENTS.STATUS.VALIDATED : DOCUMENTS.STATUS.CREATED
  };
  if (iban) {
    return {
      ...iban,
      ...documentBase
    };
  }
  return documentBase;
};
const parseMangopayUboForApp = (ubo) => ({
  ...ubo,
  id: DOCUMENTS.TYPE.UBO_DECLARATION,
  document_type: DOCUMENTS.TYPE.UBO_DECLARATION,
  status: MANGOPAY.UBO_DECLARATION_STATUS[ubo.status]
});
const parseMangopayUboDeclarationForApp = (user) => ({
  ...user,
  birthday: useToDateISOStringWithoutTimezone({ dateString: user.birthday })
});
const parseMangopayUboDeclarationListForApp = (userList) => {
  return userList.map(parseMangopayUboDeclarationForApp);
};
const Mangopay = ({ $request }) => ({
  /*
   * If IBAN isn't uploaded yet it will throw a 404 and return en empty object
   * Let's handle it as a normal document and fake it here
   */
  async getIban() {
    try {
      const data = await $request({
        url: MANGOPAY$1.iban.get,
        method: "get"
      });
      return parseMangopayIbanForApp(data);
    } catch {
      return parseMangopayIbanForApp();
    }
  },
  async postIban(payload) {
    const data = await $request({
      url: MANGOPAY$1.iban.post,
      method: "post",
      data: payload
    });
    return parseMangopayIbanForApp(data);
  },
  /*
   * UBO status needs to be mapped as normal document
   * Unlike IBAN, if it doesn't exists it automatically creates a new one
   */
  async getUBODeclaration() {
    const data = await $request({
      url: MANGOPAY$1.uboDeclaration.get,
      method: "get"
    });
    return parseMangopayUboForApp(data);
  },
  async patchUBODeclaration() {
    return await $request({
      url: MANGOPAY$1.uboDeclaration.patch,
      method: "patch"
    });
  },
  async getUBODeclarationUsers(idUbo) {
    const data = await $request({
      url: MANGOPAY$1.uboDeclaration.users.get(idUbo),
      method: "get"
    });
    return parseMangopayUboDeclarationListForApp(data);
  },
  async patchUBODeclarationUsers(idUbo, idMangopayUser, payload) {
    const data = await $request({
      url: MANGOPAY$1.uboDeclaration.users.patch(idUbo, idMangopayUser),
      method: "patch",
      data: formatUserUBOForAPI(payload)
    });
    return parseMangopayUboDeclarationForApp(data);
  },
  async postUBODeclarationUsers(idUbo, payload) {
    const data = await $request({
      url: MANGOPAY$1.uboDeclaration.users.post(idUbo),
      method: "post",
      data: formatUserUBOForAPI(payload)
    });
    return parseMangopayUboDeclarationForApp(data);
  },
  async getPayin(params) {
    if (!params.year) {
      return await Promise.reject(new Error("year is needed"));
    }
    const data = await $request({
      url: MANGOPAY$1.payin.get,
      method: "get",
      params
    });
    return parsePaymentHistoryListForApp(data);
  },
  async getPayout(params) {
    if (!params.year) {
      return await Promise.reject(new Error("year is needed"));
    }
    const data = await $request({
      url: MANGOPAY$1.payout.get,
      method: "get",
      params
    });
    return parsePaymentHistoryListForApp(data);
  }
});
const parsePeriodForApp = (period) => {
  period.date_from = useToDateISOStringWithoutTimezone({ dateString: period.date_from });
  return period;
};
const parsePeriodListForApp = (periodList) => {
  periodList.forEach(parsePeriodForApp);
  return periodList;
};
const formatPeriodForAPI = (form) => {
  return {
    ...form,
    dates_0: useToDateISOStringWithoutTime({ date: form.dates_0 }),
    dates_1: useToDateISOStringWithoutTime({ date: form.dates_1 })
  };
};
const parseStatisticsListForApp = (statisticList) => {
  statisticList.visit_stats.forEach((entry) => {
    entry[0] = useToDateISOStringWithoutTimezone({ dateString: entry[0] });
  });
  statisticList.print_stats.forEach((entry) => {
    entry[0] = useToDateISOStringWithoutTimezone({ dateString: entry[0] });
  });
  return statisticList;
};
const mapTrileanToAcceptanceStatus = (acceptanceStatus) => {
  const { ALLOWED, NOT_ALLOWED, ON_DEMAND } = PRODUCTS.OWNER_ACCEPTANCE_STATUS;
  return acceptanceStatus ? ALLOWED : acceptanceStatus === false ? NOT_ALLOWED : ON_DEMAND;
};
const mapAcceptanceStatusToTrilean = (acceptanceStatus) => {
  const { ALLOWED, NOT_ALLOWED } = PRODUCTS.OWNER_ACCEPTANCE_STATUS;
  return acceptanceStatus === ALLOWED ? true : acceptanceStatus === NOT_ALLOWED ? false : null;
};
const useStringListToArray = (value) => Array.isArray(value) ? value : useIsString(value) ? value.split(/\s?,\s?/g).filter((s) => s.length) : [];
const useToDateISOStringWithTimezone = ({
  dateString,
  hours = 0
}) => {
  if (dateString === void 0) {
    return void 0;
  }
  if (!useIsString(dateString)) {
    return null;
  }
  if (dateString.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(.\d+)?Z$/) != null) {
    return dateString;
  }
  if (dateString.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(.\d+)?$/) != null) {
    return `${dateString}Z`;
  }
  if (dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/) != null) {
    return `${dateString}T${String(hours).padStart(2, "0")}:00:00Z`;
  }
  throw new Error("dateString format is not valid");
};
const parseProductForApp = (camperItem) => {
  const { deposit_mean, vehicle_owner_language_spoke, published_at, abroad_allowed, smoking_allowed, pets_allowed, ...origin } = camperItem;
  return {
    ...origin,
    deposit_mean: useStringListToArray(deposit_mean),
    vehicle_owner_language_spoke: useStringListToArray(vehicle_owner_language_spoke),
    published_at: useToDateISOStringWithTimezone({ dateString: published_at }),
    abroad_allowed: mapTrileanToAcceptanceStatus(abroad_allowed),
    smoking_allowed: mapTrileanToAcceptanceStatus(smoking_allowed),
    pets_allowed: mapTrileanToAcceptanceStatus(pets_allowed)
  };
};
const parseProductListForApp = (list) => {
  const { results, ...origin } = list;
  return {
    ...origin,
    results: results.map(parseProductForApp)
  };
};
const useArrayToStringList = (value) => Array.isArray(value) && value.length > 0 ? value.join(",") : null;
const formatProductForAPI = (form) => {
  return {
    ...form,
    deposit_mean: form.deposit_mean ? useArrayToStringList(form.deposit_mean.filter((d) => PRICES.DEPOSIT_MEAN.includes(d))) : void 0,
    abroad_allowed: form.abroad_allowed ? mapAcceptanceStatusToTrilean(form.abroad_allowed) : void 0,
    pets_allowed: form.abroad_allowed ? mapAcceptanceStatusToTrilean(form.pets_allowed) : void 0,
    smoking_allowed: form.abroad_allowed ? mapAcceptanceStatusToTrilean(form.smoking_allowed) : void 0,
    vehicle_owner_language_spoke: form.vehicle_owner_language_spoke ? useArrayToStringList(form.vehicle_owner_language_spoke) : void 0
  };
};
const formatAvailabilitiesForAPI = (params) => {
  return {
    ...params,
    date_from: useToDateISOStringWithoutTime({ date: params.date_from }),
    date_to: useToDateISOStringWithoutTime({ date: params.date_to })
  };
};
const parsePeriodPriceForApp = (price) => {
  return {
    ...price,
    deposit_mean: useStringListToArray(price.deposit_mean)
  };
};
const formatPeriodPriceForAPI = (form) => {
  return {
    ...form,
    deposit_mean: form.deposit_mean ? useArrayToStringList(form.deposit_mean.filter((d) => PRICES.DEPOSIT_MEAN.includes(d))) : void 0
  };
};
const Products = ({ $request }) => ({
  async getMine(params = {}) {
    const data = await $request({
      url: PRODUCTS$1.me.get,
      method: "get",
      params
    });
    return parseProductListForApp(data);
  },
  async getMineFilters() {
    return await $request({
      url: PRODUCTS$1.me.filters.get,
      method: "get"
    });
  },
  async get(idProduct, params = {}) {
    const data = await $request({
      url: PRODUCTS$1.details.get(idProduct),
      method: "get",
      params
    });
    return parseProductForApp(data);
  },
  async delete(idProduct, params = {}) {
    return await $request({
      url: PRODUCTS$1.details.delete(idProduct),
      method: "delete",
      params
    });
  },
  async suspend(idProduct, params = {}) {
    params.soft = true;
    return await $request({
      url: PRODUCTS$1.details.delete(idProduct),
      method: "delete",
      params
    });
  },
  async reactivate(idProduct) {
    return await $request({
      url: PRODUCTS$1.details.post(idProduct),
      method: "post"
    });
  },
  async updatePreferences(idProduct, payload) {
    const product = await $request({
      url: PRODUCTS$1.details.preferences.patch(idProduct),
      method: "patch",
      data: formatProductForAPI(payload)
    });
    return parseProductForApp(product);
  },
  async getStats(idProduct) {
    const data = await $request({
      url: PRODUCTS$1.details.stats.get(idProduct),
      method: "get"
    });
    return parseStatisticsListForApp(data);
  },
  async getProgress(idProduct) {
    return await $request({
      url: PRODUCTS$1.details.progress.get(idProduct),
      method: "get"
    });
  },
  async getPeriods(idProduct, params = {}) {
    const data = await $request({
      url: PRODUCTS$1.details.calendar.periods.get(idProduct),
      method: "get",
      params
    });
    return parsePeriodListForApp(data);
  },
  async createPeriod(idProduct, payload) {
    const data = await $request({
      url: PRODUCTS$1.details.calendar.periods.post(idProduct),
      method: "post",
      data: formatPeriodForAPI(payload)
    });
    return parsePeriodForApp(data);
  },
  async updatePeriod(idProduct, idPeriod, payload) {
    const data = await $request({
      url: PRODUCTS$1.details.calendar.periods.details.patch(idProduct, idPeriod),
      method: "patch",
      data: formatPeriodForAPI(payload)
    });
    return parsePeriodForApp(data);
  },
  async deletePeriod(idProduct, idPeriod) {
    return await $request({
      url: PRODUCTS$1.details.calendar.periods.details.delete(idProduct, idPeriod),
      method: "delete"
    });
  },
  async getPrices(idProduct) {
    return await $request({
      url: PRODUCTS$1.details.calendar.prices.get(idProduct),
      method: "get"
    });
  },
  async createPrice(idProduct, payload) {
    return await $request({
      url: PRODUCTS$1.details.calendar.prices.post(idProduct),
      method: "post",
      data: payload
    });
  },
  async updatePrice(idProduct, idPrice, payload) {
    return await $request({
      url: PRODUCTS$1.details.calendar.prices.details.patch(idProduct, idPrice),
      method: "patch",
      data: payload
    });
  },
  async deletePrice(idProduct, idPrice) {
    return await $request({
      url: PRODUCTS$1.details.calendar.prices.details.delete(idProduct, idPrice),
      method: "delete"
    });
  },
  async getPricesDetails(idProduct) {
    const data = await $request({
      url: PRODUCTS$1.details.prices.get(idProduct),
      method: "get"
    });
    return parsePeriodPriceForApp(data);
  },
  async updatePricesDetails(idProduct, payload) {
    return await $request({
      url: PRODUCTS$1.details.prices.patch(idProduct),
      method: "patch",
      data: formatPeriodPriceForAPI(payload)
    });
  },
  async createOptions(idProduct, payload) {
    return await $request({
      url: PRODUCTS$1.details.options.post(idProduct),
      method: "post",
      data: payload
    });
  },
  async updateOptions(idProduct, payload) {
    return await $request({
      url: PRODUCTS$1.details.options.patch(idProduct),
      method: "patch",
      data: payload
    });
  },
  async deleteOptions(idProduct, payload) {
    return await $request({
      url: PRODUCTS$1.details.options.delete(idProduct),
      method: "delete",
      data: payload
    });
  },
  async getBookingRequestPrices(idProduct, params) {
    return await $request({
      url: PRODUCTS$1.details.prices.request.get(idProduct),
      method: "get",
      params
    });
  },
  async getAvailabilities(idProduct, params) {
    return await $request({
      url: PRODUCTS$1.details.availabilities.get(idProduct),
      method: "get",
      params: formatAvailabilitiesForAPI(params)
    });
  },
  async getUrlToDuplicateAdInGoboony(idProduct) {
    return await $request({
      url: PRODUCTS$1.details.goboony.duplicateRedirectUrl(idProduct),
      method: "get"
    });
  },
  async getCalendarFeed(idProduct) {
    const data = await $request({
      url: PRODUCTS$1.details.calendar.feed.get(idProduct),
      method: "get"
    });
    return parseProductForApp(data);
  },
  async createIcalFeed(idProduct, payload) {
    const data = await $request({
      url: PRODUCTS$1.details.calendar.feed.post(idProduct),
      method: "post",
      data: payload
    });
    return parseProductForApp(data);
  },
  async deleteIcalFeed(idProduct) {
    return await $request({
      url: PRODUCTS$1.details.calendar.feed.delete(idProduct),
      method: "delete"
    });
  }
});
const nullToArray = ["cooking_energies", "heating_energies", "fridge_energies", "electric_plug_types"];
const parseForApp$2 = (equipments) => {
  return {
    ...equipments,
    ...nullToArray.reduce(
      (acc, key) => ({
        ...acc,
        [key]: equipments[key] === null ? [] : equipments[key]
      }),
      {}
    )
  };
};
const formatForAPI = (form) => {
  const payload = Object.assign({}, form);
  nullToArray.forEach((key) => {
    if (payload[key] === null) {
      payload[key] = [];
    }
  });
  return payload;
};
const parseVehicleForApp = (vehicle) => {
  return {
    ...vehicle,
    date: useToDateISOStringWithoutTimezone({ dateString: vehicle.date }),
    equipments: parseForApp$2(vehicle.equipments)
  };
};
const formatVehicleForAPI = (form) => {
  const payload = Object.assign({}, form);
  if (payload.date) {
    payload.date = useToDateISOStringWithoutTime({ date: payload.date });
  }
  return payload;
};
const Vehicles = ({ $request }) => ({
  async get(idVehicle) {
    const data = await $request({
      url: VEHICLES$1.details.get(idVehicle),
      method: "get"
    });
    return parseVehicleForApp(data);
  },
  async update(idVehicle, payload) {
    const data = await $request({
      url: VEHICLES$1.details.patch(idVehicle),
      method: "patch",
      data: formatVehicleForAPI(payload)
    });
    return parseVehicleForApp(data);
  },
  async create(payload) {
    return await $request({
      url: VEHICLES$1.details.post,
      method: "post",
      data: formatVehicleForAPI(payload)
    }).then(parseVehicleForApp);
  },
  async getEquipments(idVehicle) {
    const data = await $request({
      url: VEHICLES$1.details.equipments.get(idVehicle),
      method: "get"
    });
    return parseForApp$2(data);
  },
  async updateEquipments(idVehicle, payload) {
    const data = await $request({
      url: VEHICLES$1.details.equipments.patch(idVehicle),
      method: "patch",
      data: formatForAPI(payload)
    });
    return parseForApp$2(data);
  },
  async getSleepings(idVehicle) {
    return await $request({
      url: VEHICLES$1.details.sleepings.get(idVehicle),
      method: "get"
    });
  },
  async createSleeping(idVehicle, payload) {
    return await $request({
      url: VEHICLES$1.details.sleepings.post(idVehicle),
      method: "post",
      data: payload
    });
  },
  async deleteSleeping(idVehicle, idSleeping) {
    return await $request({
      url: VEHICLES$1.details.sleepings.delete(idVehicle, idSleeping),
      method: "delete"
    });
  },
  async getPhotos(idVehicle) {
    return await $request({
      url: VEHICLES$1.details.photos.get(idVehicle),
      method: "get"
    });
  },
  async uploadPhoto(idVehicle, payload) {
    return await $request({
      url: VEHICLES$1.details.photos.post(idVehicle),
      method: "post",
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  async updatePhoto(idVehicle, idPicture, payload) {
    return await $request({
      url: VEHICLES$1.details.photos.details.patch(idVehicle, idPicture),
      method: "patch",
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  async rotatePhoto(idVehicle, idPicture) {
    return await $request({
      url: VEHICLES$1.details.photos.details.rotate.patch(idVehicle, idPicture),
      method: "patch"
    });
  },
  async deletePhoto(idVehicle, idPicture) {
    return await $request({
      url: VEHICLES$1.details.photos.details.delete(idVehicle, idPicture),
      method: "delete"
    });
  }
});
const formatDocumentForAPI = (payload) => {
  return {
    ...payload,
    expiration_date: useToDateISOStringWithoutTime({ date: payload.expiration_date }),
    real_edition_date: useToDateISOStringWithoutTime({ date: payload.real_edition_date })
  };
};
const parseDocumentForApp = (document) => {
  document.expiration_date = useToDateISOStringWithoutTimezone({ dateString: document.expiration_date });
  document.real_edition_date = useToDateISOStringWithoutTimezone({ dateString: document.real_edition_date });
  return document;
};
const parseDocumentListForApp = (list) => list.map(parseDocumentForApp);
const Documents = ({ $request }) => ({
  async getByIdVehicle(idVehicle) {
    const data = await $request({
      url: DOCUMENTS$1.details.vehicle.get(idVehicle),
      method: "get"
    });
    return parseDocumentListForApp(data);
  },
  async getByIdBooking(idBooking) {
    const data = await $request({
      url: DOCUMENTS$1.details.booking.get(idBooking),
      method: "get"
    });
    return parseDocumentListForApp(data);
  },
  async getGuestDocumentsByIdUser(idUser) {
    const data = await $request({
      url: DOCUMENTS$1.details.guest.get(idUser),
      method: "get"
    });
    return parseDocumentListForApp(data);
  },
  async getOwnerDocumentsByIdUser(idUser) {
    const data = await $request({
      url: DOCUMENTS$1.details.owner.get(idUser),
      method: "get"
    });
    return parseDocumentListForApp(data);
  },
  async getById(idDocument) {
    const data = await $request({
      url: DOCUMENTS$1.details.get(idDocument),
      method: "get"
    });
    return parseDocumentForApp(data);
  },
  async update(idDocument, payload) {
    const data = await $request({
      url: DOCUMENTS$1.details.patch(idDocument),
      method: "patch",
      data: formatDocumentForAPI(payload)
    });
    return parseDocumentForApp(data);
  },
  async addDocumentPage(idDocument, payload) {
    return await $request({
      url: DOCUMENTS$1.details.page.post(idDocument),
      method: "post",
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  async removeDocumentPage(idDocument, idPage) {
    await $request({
      url: DOCUMENTS$1.details.page.delete(idDocument, idPage),
      method: "delete"
    });
  },
  async doctectiveCheck(payload) {
    await $request({
      url: DOCUMENTS$1.details.doctective.check,
      method: "post",
      data: payload
    });
  }
});
const CertifyPhone = ({ $request }) => ({
  async get() {
    await $request({
      url: CERTIFY_PHONE.get,
      method: "get"
    });
  },
  async post(payload) {
    await $request({
      url: CERTIFY_PHONE.post,
      method: "post",
      data: payload
    });
  }
});
const parseInsuranceUserConditionForApp = (insuranceUserCondition) => ({
  ...insuranceUserCondition,
  deductible_amount: parseFloat(insuranceUserCondition.deductible_amount),
  deductible_upper_parts: parseFloat(insuranceUserCondition.deductible_upper_parts),
  deductible_burglary: parseFloat(insuranceUserCondition.deductible_burglary),
  deductible_glass_breakage: parseFloat(insuranceUserCondition.deductible_glass_breakage)
});
const parseInsuranceForApp = (insuranceResponse) => ({
  ...insuranceResponse,
  damage_to_vehicle_price: insuranceResponse.damage_to_vehicle_price ? parseFloat(insuranceResponse.damage_to_vehicle_price) : null,
  damage_high_part_price: insuranceResponse.damage_high_part_price ? parseFloat(insuranceResponse.damage_high_part_price) : null,
  burglary_price: insuranceResponse.burglary_price ? parseFloat(insuranceResponse.burglary_price) : null,
  broken_glass_price: insuranceResponse.broken_glass_price ? parseFloat(insuranceResponse.broken_glass_price) : null,
  objects_protection_price: insuranceResponse.objects_protection_price ? parseFloat(insuranceResponse.objects_protection_price) : null
});
const parseRentalCoverForApp = (rentalCoverResponse) => ({
  ...rentalCoverResponse,
  damage_to_vehicle_price: parseFloat(rentalCoverResponse.damage_to_vehicle_price),
  burglary_price: parseFloat(rentalCoverResponse.burglary_price),
  broken_glass_price: parseFloat(rentalCoverResponse.broken_glass_price),
  internal_damage_price: parseFloat(rentalCoverResponse.internal_damage_price)
});
const Insurance = ({ $request }) => ({
  async get(params) {
    return await $request({
      url: INSURANCE.get,
      method: "get",
      params
    });
  },
  async getSimilar(payload) {
    const { slug, ...params } = payload;
    return await $request({
      url: INSURANCE.similar.get(slug),
      method: "get",
      params
    });
  },
  async getBySlug(slug) {
    const data = await $request({
      url: INSURANCE.details.get(slug),
      method: "get"
    });
    return parseInsuranceForApp(data);
  },
  async getUserCondition(id) {
    const insurance = await $request({
      url: INSURANCE.condition.get(id),
      method: "get"
    });
    return parseInsuranceUserConditionForApp(insurance);
  },
  async createUserCondition(id, payload) {
    const insurance = await $request({
      url: INSURANCE.condition.post(id),
      method: "post",
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return parseInsuranceUserConditionForApp(insurance);
  },
  async updateUserCondition(id, payload) {
    const insurance = await $request({
      url: INSURANCE.condition.patch(id),
      method: "patch",
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return parseInsuranceUserConditionForApp(insurance);
  },
  async getProductCondition(id) {
    const insurance = await $request({
      url: INSURANCE.productCondition.get(id),
      method: "get"
    });
    return parseInsuranceUserConditionForApp(insurance);
  },
  async createProductCondition(id, payload) {
    const insurance = await $request({
      url: INSURANCE.productCondition.post(id),
      method: "post",
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return parseInsuranceUserConditionForApp(insurance);
  },
  async updateProductCondition(id, payload) {
    const insurance = await $request({
      url: INSURANCE.productCondition.patch(id),
      method: "patch",
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return parseInsuranceUserConditionForApp(insurance);
  },
  async getRentalCoverConditions(params) {
    const rentalCover = await $request({
      method: "get",
      url: INSURANCE.rentalCover.get,
      params
    });
    return parseRentalCoverForApp(rentalCover);
  }
});
const Brands = ({ $request }) => ({
  async get(params = {}) {
    if (!params.page_size) {
      params.page_size = 500;
    }
    return await $request({
      url: BRANDS.get,
      method: "get",
      params
    });
  },
  async getModels(params = {}) {
    if (!params.page_size) {
      params.page_size = 500;
    }
    return await $request({
      url: BRANDS.models.get,
      method: "get",
      params
    });
  }
});
const Manufacturers = ({ $request }) => ({
  async get(params = {}) {
    if (!params.page_size) {
      params.page_size = 500;
    }
    return await $request({
      url: MANUFACTURERS.get,
      method: "get",
      params
    });
  },
  async getModels(params = {}) {
    if (!params.page_size) {
      params.page_size = 500;
    }
    return await $request({
      url: MANUFACTURERS.models.get,
      method: "get",
      params
    });
  }
});
const parseWishlistForApp = (wishlist) => {
  const { ad_set, ...origin } = wishlist;
  return { ...origin, ad_set: ad_set.map(parseProductForApp) };
};
const parseWishlistListForApp = (list) => list.map(parseWishlistForApp);
const Wishlists = ({ $request }) => ({
  async getAll() {
    const data = await $request({
      url: WISHLIST.get,
      method: "get"
    });
    return parseWishlistListForApp(data);
  },
  async create(payload) {
    const data = await $request({
      url: WISHLIST.post,
      method: "post",
      data: payload
    });
    return parseWishlistForApp(data);
  },
  async getBySlug(slug) {
    const data = await $request({
      url: WISHLIST.details.get(slug),
      method: "get"
    });
    return parseWishlistForApp(data);
  },
  async delete(slug) {
    await $request({
      url: WISHLIST.details.delete(slug),
      method: "delete"
    });
  },
  async update(slug, payload) {
    const data = await $request({
      url: WISHLIST.details.patch(slug),
      method: "patch",
      data: payload
    });
    return parseWishlistForApp(data);
  },
  async addProductToWishlist(slug, payload) {
    const data = await $request({
      url: WISHLIST.details.product.post(slug),
      method: "post",
      data: payload
    });
    return parseWishlistForApp(data);
  },
  async deleteProductFromWishlist(slug, payload) {
    const data = await $request({
      url: WISHLIST.details.product.delete(slug),
      method: "delete",
      data: payload
    });
    return parseWishlistForApp(data);
  }
});
const parseBookingPricesForApp = (prices) => {
  const getValueCurrency = (value, currency) => {
    if (typeof value === "number") {
      return {
        value,
        currency
      };
    }
    return {
      value: value ? parseFloat(value) : null,
      currency
    };
  };
  const { currency_used, currency_owner } = prices;
  return {
    ...prices,
    price: getValueCurrency(prices.price, currency_used),
    price_cancellation_insurance: getValueCurrency(prices.price_cancellation_insurance, currency_owner),
    price_coupon: getValueCurrency(prices.price_coupon, currency_owner),
    price_discount: getValueCurrency(prices.price_discount, currency_owner),
    price_discount_early: getValueCurrency(prices.price_discount_early, currency_owner),
    price_discount_weekly: getValueCurrency(prices.price_discount_weekly, currency_owner),
    price_fees: getValueCurrency(prices.price_fees, currency_owner),
    price_fees_ydm_owner: getValueCurrency(prices.price_fees_ydm_owner, currency_owner),
    price_fees_owner_excluding_ydm_owner: getValueCurrency(prices.price_fees_owner_excluding_ydm_owner, currency_owner),
    price_guest_per_day: getValueCurrency(prices.price_guest_per_day, currency_owner),
    price_insurance: getValueCurrency(prices.price_insurance, currency_owner),
    price_km: getValueCurrency(prices.price_km, currency_owner),
    price_options: getValueCurrency(prices.price_options, currency_owner),
    price_owner: getValueCurrency(prices.price_owner, currency_owner),
    price_second_driver: getValueCurrency(prices.price_second_driver, currency_owner),
    price_owner_per_day: getValueCurrency(prices.price_owner_per_day, currency_owner),
    price_raw: getValueCurrency(prices.price_raw, currency_owner),
    price_without_discount: getValueCurrency(prices.price_without_discount, currency_owner),
    price_rental_cover: getValueCurrency(prices.price_rental_cover, currency_owner),
    price_rental_cover_per_day: getValueCurrency(prices.price_rental_cover_per_day, currency_owner),
    price_2x_first: getValueCurrency(prices.price_2x_first, currency_owner),
    price_2x_second: getValueCurrency(prices.price_2x_second, currency_owner),
    second_payment_date: useToDateISOStringWithoutTimezone({ dateString: prices.second_payment_date })
  };
};
const parseExtensions = (bookingOwner) => {
  let day_before, day_after, km_200, km_unlimited, day_slide;
  if (bookingOwner.extensions.requests.day_before) {
    day_before = {
      ...bookingOwner.extensions.requests.day_before,
      date_time_from: useToDateISOStringWithoutTimezone({
        dateString: bookingOwner.extensions.requests.day_before.date_from,
        hours: bookingOwner.extensions.requests.day_before.hour_from
      }),
      earnings: parseFloat(bookingOwner.extensions.requests.day_before.earnings)
    };
  }
  if (bookingOwner.extensions.requests.day_after != null) {
    day_after = {
      ...bookingOwner.extensions.requests.day_after,
      date_time_to: useToDateISOStringWithoutTimezone({
        dateString: bookingOwner.extensions.requests.day_after.date_to,
        hours: bookingOwner.extensions.requests.day_after.hour_to
      }),
      earnings: parseFloat(bookingOwner.extensions.requests.day_after.earnings)
    };
  }
  if (bookingOwner.extensions.requests.day_slide != null) {
    day_slide = {
      ...bookingOwner.extensions.requests.day_slide,
      date_time_from: useToDateISOStringWithoutTimezone({
        dateString: bookingOwner.extensions.requests.day_slide.date_from,
        hours: bookingOwner.extensions.requests.day_slide.hour_from
      }),
      date_time_to: useToDateISOStringWithoutTimezone({
        dateString: bookingOwner.extensions.requests.day_slide.date_to,
        hours: bookingOwner.extensions.requests.day_slide.hour_to
      }),
      earnings: parseFloat(bookingOwner.extensions.requests.day_slide.earnings)
    };
  }
  if (bookingOwner.extensions.requests.km_200 != null) {
    km_200 = {
      ...bookingOwner.extensions.requests.km_200,
      earnings: parseFloat(bookingOwner.extensions.requests.km_200.earnings)
    };
  }
  if (bookingOwner.extensions.requests.km_unlimited != null) {
    km_unlimited = {
      ...bookingOwner.extensions.requests.km_unlimited,
      earnings: parseFloat(bookingOwner.extensions.requests.km_unlimited.earnings)
    };
  }
  return {
    ...bookingOwner.extensions,
    earnings: parseFloat(bookingOwner.extensions.earnings),
    requests: {
      day_after,
      day_before,
      day_slide,
      km_200,
      km_unlimited
    }
  };
};
const parseBookingOwnerForApp = (bookingOwner) => ({
  ...bookingOwner,
  date_time_from: useToDateISOStringWithoutTimezone({
    dateString: bookingOwner.date_from,
    hours: bookingOwner.hour_from
  }),
  date_time_to: useToDateISOStringWithoutTimezone({ dateString: bookingOwner.date_to, hours: bookingOwner.hour_to }),
  date_time_confirmed: useToDateISOStringWithTimezone({ dateString: bookingOwner.confirmed_on }),
  owner_accept_expire_on: useToDateISOStringWithTimezone({ dateString: bookingOwner.owner_accept_expire_on }),
  travelers: bookingOwner.travelers ? parseInt(bookingOwner.travelers) : null,
  total_earnings: parseFloat(bookingOwner.total_earnings),
  deposit: parseFloat(bookingOwner.deposit),
  guest: {
    ...bookingOwner.guest,
    review_average_as_guest: parseFloat(bookingOwner.guest.review_average_as_guest)
  },
  camper: {
    ...bookingOwner.camper,
    deposit: parseFloat(bookingOwner.camper.deposit),
    review_average: parseFloat(bookingOwner.camper.review_average)
  },
  extensions: parseExtensions(bookingOwner)
});
const parseBookingOwnerListForApp = (bookingList) => {
  return {
    ...bookingList,
    results: bookingList.results.map((b) => ({
      ...b,
      date_time_from: useToDateISOStringWithoutTimezone({ dateString: b.date_from, hours: b.hour_from }),
      date_time_to: useToDateISOStringWithoutTimezone({ dateString: b.date_to, hours: b.hour_to })
    }))
  };
};
const Bookings = ({ $request }) => ({
  async get(id) {
    const bookingOwner = await $request({
      url: BOOKINGS_OWNER.details.get(id),
      method: "get"
    });
    return parseBookingOwnerForApp(bookingOwner);
  },
  async getAll(params = {}) {
    if (params.state) {
      params.state = params.state.toUpperCase();
    }
    const bookingList = await $request({
      url: BOOKINGS_OWNER.get,
      method: "get",
      params
    });
    return parseBookingOwnerListForApp(bookingList);
  },
  async getOptions() {
    return await $request({
      url: BOOKINGS_OWNER.options.get,
      method: "get"
    });
  },
  async acceptBooking(id) {
    const bookingOwner = await $request({
      url: BOOKINGS_OWNER.details.accept.patch(id),
      method: "patch"
    });
    return parseBookingOwnerForApp(bookingOwner);
  },
  async cancelBooking(id, payload) {
    const bookingOwner = await $request({
      url: BOOKINGS_OWNER.details.cancel.patch(id),
      method: "patch",
      data: payload
    });
    return parseBookingOwnerForApp(bookingOwner);
  },
  async refuseBooking(id, payload) {
    const bookingOwner = await $request({
      url: BOOKINGS_OWNER.details.refuse.patch(id),
      method: "patch",
      data: payload
    });
    return parseBookingOwnerForApp(bookingOwner);
  },
  async acceptExtensions(id) {
    const bookingOwner = await $request({
      url: BOOKINGS_OWNER.details.extensions.accept.patch(id),
      method: "patch"
    });
    return parseBookingOwnerForApp(bookingOwner);
  },
  async refuseExtensions(id) {
    const bookingOwner = await $request({
      url: BOOKINGS_OWNER.details.extensions.refuse.patch(id),
      method: "patch"
    });
    return parseBookingOwnerForApp(bookingOwner);
  },
  async getPrices(id) {
    const bookingPrices = await $request({
      url: BOOKINGS_OWNER.details.prices.get(id),
      method: "get"
    });
    return parseBookingPricesForApp(bookingPrices);
  }
});
const parseMessageForApp = (message) => ({
  ...message,
  date_time_sent: useToDateISOStringWithoutTimezone({ dateString: message.send_on_tz })
});
const parseChatForApp = (chat) => ({
  ...chat,
  date_time_from: useToDateISOStringWithoutTimezone({ dateString: chat.date_from }),
  date_time_to: useToDateISOStringWithoutTimezone({ dateString: chat.date_to }),
  messages: chat.messages.map(parseMessageForApp)
});
const parseChatListForApp = (chatListItem) => ({
  ...chatListItem,
  results: chatListItem.results.map(parseChatForApp)
});
const Chats = ({ $request }) => ({
  async getAll(params) {
    const data = await $request({
      url: CHATS.get,
      method: "get",
      params
    });
    return parseChatListForApp(data);
  },
  async getChat(idChat) {
    const data = await $request({
      url: CHATS.details.get(idChat),
      method: "get"
    });
    return parseChatForApp(data);
  },
  async postChatMessage(idChat, payload) {
    const data = await $request({
      url: CHATS.details.messages.post(idChat),
      method: "post",
      data: payload
    });
    return parseMessageForApp(data);
  },
  async markAsRead(idMessage) {
    const data = await $request({
      url: CHATS.details.messages.patch(idMessage),
      method: "patch",
      data: {
        is_read: true
      }
    });
    return parseMessageForApp(data);
  }
});
const parseBookingGuestForApp = (bookingGuest) => {
  const bookingGuestDetails = {
    ...bookingGuest,
    date_time_from: useToDateISOStringWithoutTimezone({
      dateString: bookingGuest.date_from,
      hours: bookingGuest.hour_from
    }),
    date_time_to: useToDateISOStringWithoutTimezone({ dateString: bookingGuest.date_to, hours: bookingGuest.hour_to }),
    date_time_acceptation_expired: useToDateISOStringWithTimezone({ dateString: bookingGuest.acceptation_expired_on }),
    date_time_confirmed: useToDateISOStringWithTimezone({ dateString: bookingGuest.confirmed_on }),
    travelers: parseInt(bookingGuest.travelers),
    price: parseFloat(bookingGuest.price),
    deposit: parseFloat(bookingGuest.deposit),
    camper: {
      ...bookingGuest.camper,
      is_ambassador: !!bookingGuest.camper.is_ambassador,
      review_average: parseFloat(bookingGuest.camper.review_average),
      deposit: parseFloat(bookingGuest.camper.deposit)
    },
    owner: {
      ...bookingGuest.owner,
      date_time_joined_on: useToDateISOStringWithTimezone({ dateString: bookingGuest.owner.joined_on }),
      answer_rate_as_owner: parseFloat(bookingGuest.owner.answer_rate_as_owner)
    },
    upgrades: {
      ...bookingGuest.upgrades,
      price_total: parseFloat(bookingGuest.upgrades.price_total),
      price: parseFloat(bookingGuest.upgrades.price),
      fees: parseFloat(bookingGuest.upgrades.fees)
    },
    extensions: {
      ...bookingGuest.extensions,
      price_total: parseFloat(bookingGuest.extensions.price_total),
      price: parseFloat(bookingGuest.extensions.price),
      fees: parseFloat(bookingGuest.extensions.fees),
      requests: {
        km_200: null,
        km_unlimited: null,
        day_before: null,
        day_after: null,
        day_slide: null
      },
      rules: {
        ...bookingGuest.extensions.rules,
        earliest_date_time_from: useToDateISOStringWithoutTimezone({
          dateString: bookingGuest.extensions.rules.earliest_date_from
        }),
        latest_date_time_to: useToDateISOStringWithoutTimezone({
          dateString: bookingGuest.extensions.rules.latest_date_to
        }),
        earliest_date_time_from_date_slide: useToDateISOStringWithoutTimezone({
          dateString: bookingGuest.extensions.rules.earliest_date_from_date_slide
        }),
        latest_date_time_from_date_slide: useToDateISOStringWithoutTimezone({
          dateString: bookingGuest.extensions.rules.latest_date_from_date_slide
        })
      }
    }
  };
  if (bookingGuest.extensions.requests.day_before) {
    bookingGuestDetails.extensions.requests.day_before = {
      ...bookingGuest.extensions.requests.day_before,
      date_time_from: useToDateISOStringWithoutTimezone({
        dateString: bookingGuest.extensions.requests.day_before.date_from,
        hours: bookingGuest.extensions.requests.day_before.hour_from
      }),
      price_total: parseFloat(bookingGuest.extensions.requests.day_before.price_total)
    };
  }
  if (bookingGuest.extensions.requests.day_after) {
    bookingGuestDetails.extensions.requests.day_after = {
      ...bookingGuest.extensions.requests.day_after,
      date_time_to: useToDateISOStringWithoutTimezone({
        dateString: bookingGuest.extensions.requests.day_after.date_to,
        hours: bookingGuest.extensions.requests.day_after.hour_to
      }),
      price_total: parseFloat(bookingGuest.extensions.requests.day_after.price_total)
    };
  }
  if (bookingGuest.extensions.requests.km_200) {
    bookingGuestDetails.extensions.requests.km_200 = {
      ...bookingGuest.extensions.requests.km_200,
      price_total: parseFloat(bookingGuest.extensions.requests.km_200.price_total)
    };
  }
  if (bookingGuest.extensions.requests.km_unlimited) {
    bookingGuestDetails.extensions.requests.km_unlimited = {
      ...bookingGuest.extensions.requests.km_unlimited,
      price_total: parseFloat(bookingGuest.extensions.requests.km_unlimited.price_total)
    };
  }
  if (bookingGuest.extensions.requests.day_slide) {
    bookingGuestDetails.extensions.requests.day_slide = {
      ...bookingGuest.extensions.requests.day_slide,
      date_time_from: useToDateISOStringWithoutTimezone({
        dateString: bookingGuest.extensions.requests.day_slide.date_from,
        hours: bookingGuest.extensions.requests.day_slide.hour_from
      }),
      date_time_to: useToDateISOStringWithoutTimezone({
        dateString: bookingGuest.extensions.requests.day_slide.date_to,
        hours: bookingGuest.extensions.requests.day_slide.hour_to
      }),
      price_total: parseFloat(bookingGuest.extensions.requests.day_slide.price_total)
    };
  }
  return bookingGuestDetails;
};
const parseBookingListForApp = (bookingList) => {
  return {
    ...bookingList,
    results: bookingList.results.map((b) => ({
      ...b,
      date_time_from: useToDateISOStringWithoutTimezone({ dateString: b.date_from, hours: b.hour_from }),
      date_time_to: useToDateISOStringWithoutTimezone({ dateString: b.date_to, hours: b.hour_to }),
      price: parseFloat(b.price),
      camper: {
        ...b.camper,
        review_average: parseFloat(b.camper.review_average)
      }
    }))
  };
};
const parseBookingGuestUpgradesForApp = (createBookingGuestResponse) => ({
  ...createBookingGuestResponse,
  price_total: parseFloat(createBookingGuestResponse.price_total),
  price: parseFloat(createBookingGuestResponse.price),
  fees: parseFloat(createBookingGuestResponse.fees)
});
const Requests = ({ $request }) => ({
  async createRequest(payload) {
    const data = await $request({
      url: BOOKINGS_GUEST.post,
      method: "post",
      data: payload
    });
    return parseBookingGuestForApp(data);
  },
  async patchRequest(id, payload) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.patch(id),
      method: "patch",
      data: payload
    });
    return parseBookingGuestForApp(data);
  },
  async get(id) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.get(id),
      method: "get"
    });
    return parseBookingGuestForApp(data);
  },
  async getAll(params) {
    if (params.state) {
      params.state = params.state.toUpperCase();
    }
    const data = await $request({
      url: BOOKINGS_GUEST.get,
      method: "get",
      params
    });
    return parseBookingListForApp(data);
  },
  async getOptions() {
    return await $request({
      url: BOOKINGS_GUEST.options.get,
      method: "get"
    });
  },
  async getPrices(id, params) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.prices.get(id),
      method: "get",
      params
    });
    return parseBookingPricesForApp(data);
  },
  async patchPrices(id, payload) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.prices.patch(id),
      method: "patch",
      data: payload
    });
    return parseBookingPricesForApp(data);
  },
  async snooze(id) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.snooze.patch(id),
      method: "patch"
    });
    return parseBookingGuestForApp(data);
  },
  async cancel(id, payload) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.cancel.patch(id),
      method: "patch",
      data: payload
    });
    return parseBookingGuestForApp(data);
  },
  async validate(id) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.validate.patch(id),
      method: "patch"
    });
    return parseBookingGuestForApp(data);
  },
  async postExtensionRequest(id, payload) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.extensions.post(id),
      method: "post",
      data: payload
    });
    return parseBookingGuestForApp(data);
  },
  async validateExtensions(id) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.extensions.validate.patch(id),
      method: "patch"
    });
    return parseBookingGuestForApp(data);
  },
  async confirmExtensions(id) {
    return await $request({
      url: BOOKINGS_GUEST.details.extensions.confirm.get(id),
      method: "get"
    });
  },
  async cancelExtensions(id) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.extensions.cancel.patch(id),
      method: "patch"
    });
    return parseBookingGuestForApp(data);
  },
  async deleteExtensionRequest(id, idExtension) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.extensions.details.delete(id, idExtension),
      method: "delete"
    });
    return parseBookingGuestForApp(data);
  },
  async getUpgrade(id, params) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.upgrades.get(id),
      method: "get",
      params
    });
    return parseBookingGuestUpgradesForApp(data);
  },
  async postUpgrade(id, payload) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.upgrades.post(id),
      method: "post",
      data: payload
    });
    return parseBookingGuestForApp(data);
  },
  async validateUpgrades(id) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.upgrades.validate.patch(id),
      method: "patch"
    });
    return parseBookingGuestForApp(data);
  },
  async cancelUpgrades(id) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.upgrades.cancel.patch(id),
      method: "patch"
    });
    return parseBookingGuestForApp(data);
  },
  async deleteUpgrade(id, idUpgrade) {
    const data = await $request({
      url: BOOKINGS_GUEST.details.upgrades.details.delete(id, idUpgrade),
      method: "delete"
    });
    return parseBookingGuestForApp(data);
  },
  async getPayment(id) {
    return await $request({
      url: BOOKINGS_GUEST.details.payments.get(id),
      method: "get"
    });
  },
  async getSinglePayment(id, params) {
    return await $request({
      url: BOOKINGS_GUEST.details.payment.get(id),
      method: "get",
      params
    });
  },
  async getPaymentSummary(id) {
    return await $request({
      url: BOOKINGS_GUEST.details.payments.summary.get(id),
      method: "get"
    });
  },
  async getPaymentWebRedirect(id, params) {
    return await $request({
      url: BOOKINGS_GUEST.details.payments.webRedirect.get(id),
      method: "get",
      params
    });
  },
  async postPaymentSummary(id, payload) {
    return await $request({
      url: BOOKINGS_GUEST.details.payments.summary.post(id),
      method: "post",
      data: payload
    });
  },
  async confirmPayment(id, payload) {
    return await $request({
      url: BOOKINGS_GUEST.details.payments.confirm.post(id),
      method: "post",
      data: payload
    });
  },
  async finalizePayment(id, params) {
    return await $request({
      url: BOOKINGS_GUEST.details.payments.final.get(id),
      method: "get",
      params
    });
  },
  async getRefunds(id) {
    return await $request({
      url: BOOKINGS_GUEST.details.refund.get(id),
      method: "get"
    });
  },
  async createAsyncPayment(id, payload) {
    return await $request({
      url: BOOKINGS_GUEST.details.payments.async.post(id),
      method: "post",
      data: payload
    });
  },
  async getAsyncPayment(id, payinId) {
    return await $request({
      url: BOOKINGS_GUEST.details.payments.async.get(id, payinId),
      method: "get"
    });
  }
});
const parseReviewForApp = (reviewListItem) => {
  return {
    ...reviewListItem,
    date_time_published: useToDateISOStringWithTimezone({ dateString: reviewListItem.published_date })
  };
};
const parseReviewListForApp = (reviewList) => {
  const { results, ...origin } = reviewList;
  return {
    ...origin,
    results: results.map(parseReviewForApp)
  };
};
const parseReviewNeededForApp = (reviewNeededListItem) => {
  return {
    ...reviewNeededListItem,
    date_time_from: useToDateISOStringWithoutTimezone({
      dateString: reviewNeededListItem.date_from,
      hours: reviewNeededListItem.hour_from
    }),
    date_time_to: useToDateISOStringWithoutTimezone({
      dateString: reviewNeededListItem.date_to,
      hours: reviewNeededListItem.hour_to
    }),
    guest: {
      id: reviewNeededListItem.guest_id,
      first_name: reviewNeededListItem.guest_first_name,
      photo: reviewNeededListItem.guest_picture
    },
    owner: {
      id: reviewNeededListItem.owner_id,
      first_name: reviewNeededListItem.owner_first_name,
      photo: reviewNeededListItem.owner_picture
    }
  };
};
const parseReviewNeededListForApp = (reviewNeededList) => {
  const { results, ...origin } = reviewNeededList;
  return {
    ...origin,
    results: results.map(parseReviewNeededForApp)
  };
};
const Reviews = ({ $request }) => ({
  async getAll(params = {}) {
    const data = await $request({
      url: REVIEWS.get,
      method: "get",
      params
    });
    return parseReviewListForApp(data);
  },
  async create(idBooking, payload) {
    return await $request({
      url: REVIEWS.details.post(idBooking),
      method: "post",
      data: payload
    });
  },
  async get(idReview) {
    return await $request({
      url: REVIEWS.details.get(idReview),
      method: "get"
    });
  },
  async update(idReview, payload) {
    return await $request({
      url: REVIEWS.details.patch(idReview),
      method: "patch",
      data: payload
    });
  },
  async updatePhoto(idReview, payload) {
    return await $request({
      url: REVIEWS.details.photo.patch(idReview),
      method: "patch",
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  async reportReview(idReview) {
    return await $request({
      url: REVIEWS.details.report.patch(idReview),
      method: "patch"
    });
  },
  async getReviewsNeeded(params = {}) {
    const data = await $request({
      url: REVIEWS.needed.get,
      method: "get",
      params
    });
    return parseReviewNeededListForApp(data);
  }
});
const parseProductSearchForApp = (searchProduct) => {
  let price_per_day = null;
  if (searchProduct.price_per_day !== null) {
    price_per_day = parseFloat(searchProduct.price_per_day);
  }
  let final_booking_price = null;
  if (searchProduct.final_booking_price !== null) {
    final_booking_price = parseFloat(searchProduct.final_booking_price);
  }
  let original_booking_price = null;
  if (searchProduct.original_booking_price !== null) {
    original_booking_price = parseFloat(searchProduct.original_booking_price);
  }
  let hour_from = null;
  if (searchProduct.hour_from) {
    hour_from = parseInt(searchProduct.hour_from.substring(0, 2));
  }
  let hour_to = null;
  if (searchProduct.hour_to) {
    hour_to = parseInt(searchProduct.hour_to.substring(0, 2));
  }
  return {
    ...searchProduct,
    price_per_day,
    final_booking_price,
    original_booking_price,
    hour_from,
    hour_to
  };
};
const parseProductSearchListForApp = (searchProductsList) => {
  return {
    ...searchProductsList,
    results: searchProductsList.results.map(parseProductSearchForApp)
  };
};
const entriesFromObject = (o) => {
  return Object.entries(o);
};
const Search = ({ $request }) => ({
  async getLocations(params) {
    return await $request({
      url: SEARCH.get,
      method: "get",
      params
    });
  },
  async getLocationsInfos(params) {
    return await $request({
      url: SEARCH.info.get,
      method: "get",
      params
    });
  },
  async searchProducts(params = {}) {
    const _params = new URLSearchParams();
    for (const [key, value] of entriesFromObject(params)) {
      if (Array.isArray(value)) {
        for (const p of value) {
          _params.append(String(key), String(p));
        }
      } else {
        _params.append(String(key), String(value));
      }
    }
    if (!_params.has("page_size")) {
      _params.append("page_size", "20");
    }
    const productSearchList = await $request({
      url: SEARCH.products.get,
      method: "get",
      params: _params
    });
    return parseProductSearchListForApp(productSearchList);
  }
});
const Faq = ({ $request }) => ({
  async lookFor(params = {}) {
    return await $request({
      method: "get",
      url: FAQ.get,
      params
    });
  },
  async getTopic(topic, params = {}) {
    return await $request({
      method: "get",
      url: FAQ.topic.get(topic),
      params
    });
  }
});
const mapValueText = (entry) => ({ value: entry[0], text: entry[1] });
const reduceDoubleArray = (acc, cur) => {
  acc[cur[0]] = cur[1];
  return acc;
};
const computeCountryOptions = (countries, locale = null) => {
  const countryOptions = Object.entries(countries).map(([value, text]) => ({ value, text })).sort((a, b) => a.text.localeCompare(b.text));
  locale = locale ? locale.slice(-2).toUpperCase() : null;
  const i = countryOptions.findIndex((opt) => opt.value === locale);
  if (i >= 0) {
    const option = countryOptions[i];
    countryOptions.splice(i, 1);
    countryOptions.splice(0, 0, option);
  }
  return countryOptions;
};
const HOUR_FROM_GMT1_AS_NUMBER = [9, 14];
const HOUR_TO_GMT1_AS_NUMBER = [12, 20];
const HOUR_MAP = [...HOUR_FROM_GMT1_AS_NUMBER, ...HOUR_TO_GMT1_AS_NUMBER].reduce((acc, cur) => {
  acc[cur] = Date.UTC(0, 0, 0, cur, 0, 0, 0);
  return acc;
}, {});
const parseForApp$1 = (referential, locale) => {
  const {
    guide_owner,
    guide_guest,
    email_address,
    cancellation_insurance_terms,
    site_terms,
    phone_number,
    vehicle_image_type,
    reason_period_unavailable,
    reason_period_unavailable_edition,
    cancel_reason_owner,
    cancel_reason_guest,
    deposit_mean,
    civility,
    language,
    vehicle_type_choices,
    additive_types,
    energie_types,
    sleeping_types,
    countries,
    km_values,
    currency,
    fuel_types,
    gear_types,
    option_display,
    reason_suspend_delete_ad,
    consumption_values,
    insurance_wording,
    calendar_rules,
    ordered_countries_main,
    ordered_countries_others,
    code_error_payment,
    code_error_payin,
    default_wording_code_error_payment,
    payment_type_available,
    second_driver_fees,
    second_driver_fees_currency,
    mangopay,
    spoken_language_list,
    site_language_list,
    min_days_future_rental_choices,
    max_months_future_rental_choices,
    booking_min_days
  } = referential;
  const options = {
    reason_period_unavailable: reason_period_unavailable.map(mapValueText),
    reason_period_unavailable_edition: (reason_period_unavailable_edition ?? reason_period_unavailable).map(mapValueText),
    cancel_reason_owner: cancel_reason_owner.map(mapValueText),
    cancel_reason_guest: cancel_reason_guest.map(mapValueText),
    reason_suspend_delete_ad: reason_suspend_delete_ad.map(mapValueText),
    deposit_mean: deposit_mean.map(mapValueText),
    civility: [{ value: null, text: "" }, ...civility.map(mapValueText)],
    currency: [{ value: null, text: "" }, ...currency.map((v) => ({ value: v[0], text: `${v[1]} (${v[0]})` }))],
    /** @deprecated use spoken_language_list or  site_language_list instead */
    language: language.map((v) => ({ value: v[0].toLowerCase(), text: v[1] })),
    spoken_language_list: spoken_language_list.map(mapValueText),
    site_language_list: site_language_list.map((value) => ({ value: value.toLowerCase(), text: value })),
    vehicle_type_choices: vehicle_type_choices.map((v) => ({
      value: +v[0],
      text: v[1]
    })),
    additive_types: additive_types.map(mapValueText),
    energie_types: energie_types.map(mapValueText),
    sleeping_types: sleeping_types.map(mapValueText),
    mileageEstimate: km_values.map(mapValueText),
    consumption_values: consumption_values.map(mapValueText),
    fuel_types: fuel_types.map((v) => ({
      value: v[0],
      text: v[1].toLowerCase()
    })),
    country: computeCountryOptions(countries, locale),
    countries_main: computeCountryOptions(ordered_countries_main, locale),
    countries_others: computeCountryOptions(ordered_countries_others),
    hour_from: HOUR_FROM_GMT1_AS_NUMBER.map((value) => ({
      value,
      text: HOUR_MAP[value]
    })),
    hour_to: HOUR_TO_GMT1_AS_NUMBER.map((value) => ({
      value,
      text: HOUR_MAP[value]
    })),
    professional_types: [
      { value: null, text: "" },
      { value: USERS.PROFESIONAL_TYPES.SOLE_TRADER, text: "sole_trader" },
      { value: USERS.PROFESIONAL_TYPES.BUSINESS, text: "business" }
    ],
    gear_types: gear_types.map((v) => ({
      value: v[0],
      text: v[1].toLowerCase()
    }))
  };
  const maps = {
    hour: HOUR_MAP,
    option_display: option_display.reduce((acc, cur) => {
      acc[cur.tag] = cur;
      return acc;
    }, {}),
    currency: currency.map((c) => c[0]).reduce((acc, currency2) => {
      acc[currency2] = {
        currency: currency2,
        currencyDisplay: "symbol",
        style: "currency"
      };
      return acc;
    }, {}),
    currency_symbol: currency.reduce(reduceDoubleArray, {}),
    deposit_mean: deposit_mean.reduce(reduceDoubleArray, {}),
    language: language.reduce((acc, cur) => {
      acc[cur[0].toLowerCase()] = cur[1];
      return acc;
    }, {}),
    reason_period_unavailable: reason_period_unavailable.reduce(reduceDoubleArray, {}),
    vehicle_image_type: vehicle_image_type.reduce(reduceDoubleArray, {}),
    vehicle_type_as_int: {
      1: { key: "lowprofile" },
      2: { key: "coachbuilt" },
      3: { key: "aclass" },
      4: { key: "campervan" },
      5: { key: "van" },
      6: { key: "caravan" },
      7: { key: "other" }
    },
    vehicle_equipments: {
      driving_confort: [
        { category: "driving", value: "automatic_gear" },
        { category: "driving", value: "gps" },
        { category: "driving", value: "parking_aid_radar" },
        { category: "driving", value: "parking_aid_camera" },
        { category: "driving", value: "baby_seat" },
        { category: "driving", value: "bluetooth" },
        { category: "driving", value: "ipod_input" }
      ],
      on_board: [
        { category: "kitchen_meal", value: "cooking" },
        { category: "kitchen_meal", value: "sink" },
        { category: "kitchen_meal", value: "dishes_kit" },
        { category: "kitchen_meal", value: "fridge" },
        { category: "kitchen_meal", value: "freezer" },
        { category: "kitchen_meal", value: "oven" },
        { category: "kitchen_meal", value: "cookware" },
        { category: "life_on_board", value: "bedding" },
        { category: "driving", value: "ac" },
        { category: "life_on_board", value: "ac_premium" },
        { category: "driving", value: "heating" },
        { category: "life_on_board", value: "tv" },
        { category: "toilet", value: "shower_int" },
        { category: "toilet", value: "wc" },
        { category: "toilet", value: "bathroom_sink" }
      ],
      outdoor: [
        { category: "outside", value: "side_blind" },
        { category: "outside", value: "camping_table" },
        { category: "outside", value: "bicycle" },
        { category: "outside", value: "sout_luggage" },
        { category: "outside", value: "sout_garage" },
        { category: "outside", value: "sout_adjustable" },
        { category: "autonomy-details", value: "solar" },
        { category: "outside", value: "barbecue" },
        { category: "outside", value: "towbar" }
      ]
    },
    code_error_payment: code_error_payment.reduce(
      (acc, cur) => {
        const [codes, [title, ...description]] = cur;
        for (const val of codes) {
          acc[val] = {
            title,
            description: description.join(" ")
          };
        }
        return acc;
      },
      { default: { title: default_wording_code_error_payment[0], description: default_wording_code_error_payment[1] } }
    ),
    code_error_payin: code_error_payin.reduce((acc, [code, title]) => {
      acc[code] = { title };
      return acc;
    }, {})
  };
  return {
    guide_owner,
    guide_guest,
    email_address,
    cancellation_insurance_terms,
    site_terms,
    phone_number,
    insurance_wording,
    options,
    maps,
    calendar_rules,
    payment_type_available,
    second_driver_fees,
    second_driver_fees_currency,
    mangopay,
    min_days_future_rental_choices,
    max_months_future_rental_choices,
    booking_min_days
  };
};
const Referential = ({ $request }) => ({
  async get(lang) {
    const data = await $request({
      method: "get",
      url: REFERENTIAL.get
    });
    return parseForApp$1(data[lang], lang);
  },
  async getStats() {
    const data = await $request({
      method: "get",
      url: REFERENTIAL.stats.get
    });
    return {
      ...data,
      average: parseFloat(data.average)
    };
  }
});
const Geolocation = ({ $request }) => ({
  async getPlaces(params = {}) {
    return await $request({
      method: "get",
      url: GEOLOCATION.places.get,
      params
    });
  }
});
const parseForApp = (response) => {
  const errorCodes = {
    duplicate_parameter: "email_already_exists",
    invalid_parameter: "email_is_invalid"
  };
  if ("code" in response) {
    if (errorCodes[response.code]) {
      return { error: true, code: errorCodes[response.code] };
    }
    return { error: true, code: null };
  }
  return { error: false, code: "success" };
};
const Newsletter = () => ({
  async register({
    url,
    apiKey,
    listIds,
    email
  }) {
    const res = await fetch(NEWSLETTER.register.post(url), {
      method: "POST",
      body: JSON.stringify({
        email,
        listIds: [parseInt(listIds)]
      }),
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        "api-key": apiKey
      }
    });
    const data = await res.json();
    return parseForApp(data);
  }
});
const parseEarningSimulationForApp = (earningResponse) => ({
  ...earningResponse,
  min_daily: parseInt(earningResponse.min_daily),
  max_daily: parseInt(earningResponse.max_daily),
  min_yearly: parseInt(earningResponse.min_yearly),
  max_yearly: parseInt(earningResponse.max_yearly)
});
const Earnings = ({ $request }) => ({
  async post(payload) {
    const data = await $request({
      url: EARNINGS.simulate.post,
      method: "post",
      data: payload
    });
    return parseEarningSimulationForApp(data);
  }
});
const LeadSource = ({ $request }) => ({
  async get(id) {
    return await $request({
      url: LEAD_SOURCE.get(id),
      method: "get"
    });
  }
});
const Events = ({ $request }) => ({
  post: async (payload) => {
    await $request({
      url: EVENTS.post,
      method: "post",
      data: payload
    });
  }
});
var VehicleType = /* @__PURE__ */ ((VehicleType2) => {
  VehicleType2["LowProfile"] = "LowProfile";
  VehicleType2["CoachBuilt"] = "CoachBuilt";
  VehicleType2["AClass"] = "AClass";
  VehicleType2["Campervan"] = "Campervan";
  VehicleType2["Van"] = "Van";
  VehicleType2["Caravan"] = "Caravan";
  VehicleType2["Other"] = "Other";
  return VehicleType2;
})(VehicleType || {});
var VehicleGearEnum = /* @__PURE__ */ ((VehicleGearEnum2) => {
  VehicleGearEnum2[VehicleGearEnum2["Manual"] = 1] = "Manual";
  VehicleGearEnum2[VehicleGearEnum2["Automatic"] = 2] = "Automatic";
  return VehicleGearEnum2;
})(VehicleGearEnum || {});
var VehicleFuelEnum = /* @__PURE__ */ ((VehicleFuelEnum2) => {
  VehicleFuelEnum2[VehicleFuelEnum2["Gasoline"] = 1] = "Gasoline";
  VehicleFuelEnum2[VehicleFuelEnum2["Diesel"] = 2] = "Diesel";
  VehicleFuelEnum2[VehicleFuelEnum2["LPG"] = 3] = "LPG";
  VehicleFuelEnum2[VehicleFuelEnum2["Electric"] = 4] = "Electric";
  VehicleFuelEnum2[VehicleFuelEnum2["Other"] = 5] = "Other";
  return VehicleFuelEnum2;
})(VehicleFuelEnum || {});
const api = ($axios) => ({
  instance: $axios,
  auth: Auth($axios),
  logAs: LogAs($axios),
  users: Users($axios),
  password: Password($axios),
  mangopay: Mangopay($axios),
  products: Products($axios),
  vehicles: Vehicles($axios),
  documents: Documents($axios),
  certifyPhone: CertifyPhone($axios),
  insurance: Insurance($axios),
  brands: Brands($axios),
  manufacturers: Manufacturers($axios),
  wishlists: Wishlists($axios),
  bookings: Bookings($axios),
  chats: Chats($axios),
  requests: Requests($axios),
  reviews: Reviews($axios),
  search: Search($axios),
  faq: Faq($axios),
  referential: Referential($axios),
  geolocation: Geolocation($axios),
  newsletter: Newsletter(),
  earnings: Earnings($axios),
  leadSource: LeadSource($axios),
  events: Events($axios)
});
export {
  Constants,
  VehicleFuelEnum,
  VehicleGearEnum,
  VehicleType,
  api,
  parseForApp$1 as parseReferentialForApp,
  useIsDate,
  useIsString,
  useToDateISOStringWithoutTimezone
};
